export default __webpack_public_path__ + "static/media/pack_dt2@2x.e1adfe3c.png";